<template>
    <div v-if="richCardOpen" class="card">
        <div>
            <div class="header">
                <div>
                    <slot name="header">
                    </slot>
                </div>
            </div>
            <div class="grid">
                <div class="content">
                    <slot name="content">
                    </slot>
                </div>
                <div>
                    <slot name="action"></slot>
                </div>
            </div>
        </div>
        <div :class="theClass">
            <svg class="close-button" @click="richCardOpen=false" width="24" height="24" viewBox="0 0 24 24">
                <path fill="white"
                      d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
        </div>
    </div>
</template>

<script>
    import UniCtaLink from "./UniCtaLink";

    export default {
        name: "RichCard",
        props: {
          action: {
              type: Boolean,
              default: false
          }
        },
        computed: {
          theClass() {
              if (this.action) {
                  return "grid action"
              } else {
                  return "grid"
              }
          }
        },
        components: {UniCtaLink},
        data() {
            return {
                richCardOpen: true
            }
        }
    }
</script>

<style scoped lang="scss">
    p {
        margin: 0;
    }

    a {
        margin: 0;
    }
    .grid {
        display: grid;
        grid-template-columns: 1fr;
    }

    .header {
        margin-bottom: 8px;
    }

    .card {
        display: flex;
        justify-content: space-between;
    }

    .close {
        margin-left: 8px;
    }

    .close-button {
        &:hover {
            cursor: pointer;
        }
    }

    @include screen-m {
        .grid {
            grid-template-columns: 1fr;

            /deep/ a {
                width: auto;
                justify-self: end;
                float: right;
            }

            &.action {
                grid-template-columns: 1fr 1fr;
            }
        }
        .card {
            padding: 24px;
        }
    }
</style>
